import { httpRequest } from "../../http";
import { Analytics } from "@models/analytics.model";
import type { AnalyticsFilters } from "../AnalyticsService";

const DEFAULT_CHARTS = [
    "eng-count",
    "conv-rate",
    "est-investment",
    "conversions-by-journey-step",
    "launches",
    "conv-cumulative",
    "list-count-wow",
    "top-network",
    "top-ads-list",
    "all-ads-list",
    "running-ads-list",
    "todos-list",
    "team-list",
    "ingest-metrics",
    "filter-tree",
].join(",");

export class CommandGetAnalytics {
    async run(filters: AnalyticsFilters): Promise<Analytics> {
        const params = new URLSearchParams({
            days: filters.days,
            charts: filters.charts ?? DEFAULT_CHARTS,
        });

        for (const id of filters.organizationIds) {
            params.append("organization_ids", String(id));
        }

        if (filters.status && filters.status !== "ALL") params.set("status", filters.status);
        if (filters.engagement) params.set("engagement", String(filters.engagement));
        if (filters.objective) params.set("objective", String(filters.objective));
        if (filters.launch) params.set("launch", String(filters.launch));
        if (filters.employeeId) params.set("employee_id", String(filters.employeeId));

        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/analytics/?${params.toString()}`;
        try {
            const response = await httpRequest<{
                charts: Record<string, any>;
                status_matches: number | null;
            }>(url);
            return new Analytics({
                charts: response?.charts ?? {},
                statusMatches: response?.status_matches ?? null,
            });
        } catch (error) {
            console.error("Error fetching analytics:", error);
            throw error;
        }
    }
}
